import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const Vehicles = () => {
  const server_url = localStorage.getItem("server_url");
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const navigate = useNavigate();

  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [filteredVehicles, setFilteredVehicles] = useState([]);
  const [deleteLoading, setDeleteLoading] = useState(null);
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    vehicle: null,
  });
  const [customerModal, setCustomerModal] = useState({
    isOpen: false,
    customer: null,
    loading: false,
  });

  useEffect(() => {
    fetchVehicles();
  }, []);

  useEffect(() => {
    if (searchText.trim() == "") {
      setFilteredVehicles(vehicles);
    } else {
      const searchTerm = searchText.toLowerCase();
      const filtered = vehicles.filter((vehicle) => {
        // Helper function to safely check if field contains search term
        const contains = (field) =>
          field && field.toString().toLowerCase().includes(searchTerm);

        return (
          contains(vehicle.vehicle_reg_no) ||
          contains(vehicle.vehicle_reg_name) ||
          contains(vehicle.brand_name) ||
          contains(vehicle.model_name) ||
          contains(vehicle.customer_name) ||
          (vehicle.customer_mobile &&
            vehicle.customer_mobile.includes(searchText))
        );
      });
      setFilteredVehicles(filtered);
    }
  }, [searchText, vehicles]);

  const fetchVehicles = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("customer_id", "");
      formData.append("vehicle_grage_id", userData.grage_id || "1");
      formData.append("vehicle_reg_no", "");

      const response = await axios.post(`${server_url}vehicle.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.status == "1") {
        setVehicles(response.data.result || []);
        setFilteredVehicles(response.data.result || []);
      } else {
        toast.error(response.data.error || "Failed to fetch vehicles");
        setVehicles([]);
        setFilteredVehicles([]);
      }
    } catch (error) {
      console.error("Fetch vehicles error:", error);
      toast.error("Unable to fetch vehicles. Please try again.");
      setVehicles([]);
      setFilteredVehicles([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchCustomerById = async (customerId) => {
    setCustomerModal((prev) => ({ ...prev, loading: true }));
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("customer_id", customerId);
      formData.append("customer_grage_id", userData.grage_id || "1");
      formData.append("searh_text", "");

      const response = await axios.post(`${server_url}customer.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.status == "1" && response.data.result.length > 0) {
        setCustomerModal({
          isOpen: true,
          customer: response.data.result[0],
          loading: false,
        });
      } else {
        toast.error("Customer not found");
        setCustomerModal((prev) => ({ ...prev, loading: false }));
      }
    } catch (error) {
      console.error("Fetch customer error:", error);
      toast.error("Unable to fetch customer details. Please try again.");
      setCustomerModal((prev) => ({ ...prev, loading: false }));
    }
  };

  const handleSearch = (e) => {
    if (e) e.preventDefault();
    fetchVehicles();
  };

  const handleCallCustomer = (mobile) => {
    window.open(`tel:${mobile}`);
  };

  const handleEditVehicle = (vehicle) => {
    navigate("/edit-vehicle", { state: { vehicle } });
  };

  const handleViewCustomer = (vehicle) => {
    fetchCustomerById(vehicle.customer_id);
  };

  const handleEditCustomer = (customer) => {
    setCustomerModal((prev) => ({ ...prev, isOpen: false }));
    navigate("/edit-customer", { state: { customer, isEdit: true } });
  };

  const handleAddVehicle = () => {
    navigate("/add-customer-vehicle");
  };

  const openDeleteModal = (vehicle) => {
    setDeleteModal({ isOpen: true, vehicle });
  };

  const closeDeleteModal = () => {
    setDeleteModal({ isOpen: false, vehicle: null });
  };

  const confirmDeleteVehicle = async () => {
    const vehicle = deleteModal.vehicle;
    if (!vehicle) return;

    setDeleteLoading(vehicle.vehicle_id);
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("vehicle_id", vehicle.vehicle_id);

      const response = await axios.post(
        `${server_url}delete_vehicle.php`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response.data.status == "1") {
        toast.success("Vehicle deleted successfully!");
        setVehicles((prev) =>
          prev.filter((v) => v.vehicle_id !== vehicle.vehicle_id)
        );
        setFilteredVehicles((prev) =>
          prev.filter((v) => v.vehicle_id !== vehicle.vehicle_id)
        );
        closeDeleteModal();
      } else {
        toast.error(response.data.error || "Failed to delete vehicle");
      }
    } catch (error) {
      console.error("Delete vehicle error:", error);
      toast.error("Unable to delete vehicle. Please try again.");
    } finally {
      setDeleteLoading(null);
    }
  };

  const closeCustomerModal = () => {
    setCustomerModal({ isOpen: false, customer: null, loading: false });
  };

  return (
    <div className="history-container">
      {/* Sticky Header Section */}
      <div
        className="sticky-filter"
        style={{ position: "fixed", top: "56px", width: "100%" }}
      >
        <div className="home-icon">
          <div className="section-home">
            <form onSubmit={handleSearch} className="search-form">
              <div className="input-group same-line">
                <input
                  type="text"
                  placeholder="Search vehicles..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  onKeyPress={(e) => e.key == "Enter" && handleSearch()}
                  className="search-input"
                />
                <button type="submit" className="search-btn">
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Content Area */}
      <div className="content-area">
        {/* Vehicles List */}
        <div className="home-vehicles">
          {loading ? (
            <div className="loading-vehicles">
              <div className="loading-spinner"></div>
              <div>Loading vehicles...</div>
            </div>
          ) : filteredVehicles.length > 0 ? (
            <div className="vehicles-list home-icon">
              {filteredVehicles.map((vehicle) => (
                <div
                  key={vehicle.vehicle_id}
                  className="vehicle-card section-home"
                >
                  <div className="vehicle-header">
                    <table style={{ width: "100%", textAlign: "left" }}>
                      <tbody>
                        {/* Vehicle Number */}
                        <tr>
                          <td
                            style={{
                              width: "70%",
                              fontWeight: "bold",
                              fontSize: "16px",
                            }}
                            onClick={() => handleEditVehicle(vehicle)}
                          >
                            {vehicle.vehicle_reg_no || "N/A"}
                          </td>
                          <td
                            style={{
                              textAlign: "right",
                              width: "30%",
                              fontWeight: "bold",
                              color: "#0351a0",
                            }}
                          >
                            <button
                              onClick={() => openDeleteModal(vehicle)}
                              disabled={deleteLoading == vehicle.vehicle_id}
                              style={{
                                flex: 1,
                                border: "none",
                                cursor: "pointer",
                                fontSize: "19px",
                                fontWeight: "500",
                                backgroundColor: "transparent",
                              }}
                            >
                              {deleteLoading == vehicle.vehicle_id ? (
                                <i className="fas fa-spinner fa-spin"></i>
                              ) : (
                                <>
                                  <i
                                    className="fas fa-trash"
                                    style={{
                                      marginRight: "5px",
                                      color: "#DB4437",
                                    }}
                                  ></i>
                                </>
                              )}
                            </button>
                          </td>
                        </tr>

                        {/* Registration Name */}
                        <tr>
                          <td
                            colSpan="2"
                            style={{
                              fontSize: "14px",
                              color: "#2c3e50",
                              padding: "4px 0",
                            }}
                            onClick={() => handleEditVehicle(vehicle)}
                          >
                            {vehicle.vehicle_reg_name ||
                              vehicle.customer_name ||
                              "No Name"}
                          </td>
                        </tr>

                        {/* Brand and Model */}
                        {(vehicle.brand_name || vehicle.model_name) && (
                          <tr>
                            <td
                              colSpan="2"
                              style={{
                                fontSize: "13px",
                                color: "#666",
                                padding: "2px 0",
                              }}
                              onClick={() => handleEditVehicle(vehicle)}
                            >
                              <i
                                className="fas fa-car"
                                style={{ marginRight: "8px" }}
                              ></i>
                              {vehicle.brand_name || ""}{" "}
                              {vehicle.model_name || ""}
                            </td>
                          </tr>
                        )}

                        {/* Customer Mobile */}
                        {vehicle.customer_mobile && (
                          <tr>
                            <td
                              colSpan="2"
                              style={{
                                fontSize: "13px",
                                color: "#666",
                                padding: "2px 0",
                              }}
                            >
                              <a
                                href={`tel:${vehicle.customer_mobile}`}
                                style={{
                                  color: "inherit",
                                  textDecoration: "none",
                                }}
                              >
                                <i
                                  className="fas fa-phone"
                                  style={{ marginRight: "8px" }}
                                ></i>
                                {vehicle.customer_mobile}
                              </a>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-vehicles section-home">
              <div className="no-vehicles-icon">🚗</div>
              <div className="no-vehicles-title">No Vehicles Found</div>
              <div className="no-vehicles-text">
                {searchText
                  ? "Try adjusting your search terms"
                  : "No vehicles available"}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Floating Add Button */}
      <button
        className="floating-add-btn"
        onClick={handleAddVehicle}
        title="Add New Vehicle"
      >
        <i className="fas fa-plus"></i>
      </button>

      {/* Delete Confirmation Modal */}
      {deleteModal.isOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            padding: "20px",
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "12px",
              width: "100%",
              maxWidth: "350px",
              padding: "24px",
              textAlign: "center",
            }}
          >
            <div
              style={{
                width: "60px",
                height: "60px",
                margin: "0 auto 20px",
                backgroundColor: "#fee2e2",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <i
                className="fas fa-exclamation-triangle"
                style={{ fontSize: "24px", color: "#dc2626" }}
              ></i>
            </div>

            <h3
              style={{
                margin: "0 0 12px 0",
                fontSize: "18px",
                fontWeight: "600",
                color: "#1f2937",
              }}
            >
              Delete Vehicle
            </h3>
            <p
              style={{
                margin: "0 0 24px 0",
                color: "#6b7280",
                fontSize: "14px",
              }}
            >
              Are you sure you want to delete vehicle{" "}
              <strong>{deleteModal.vehicle?.vehicle_reg_no}</strong>? This
              action cannot be undone.
            </p>

            <div style={{ display: "flex", gap: "12px" }}>
              <button
                onClick={closeDeleteModal}
                disabled={deleteLoading !== null}
                style={{
                  flex: 1,
                  padding: "12px",
                  border: "2px solid #e2e8f0",
                  background: "white",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                Cancel
              </button>
              <button
                onClick={confirmDeleteVehicle}
                disabled={deleteLoading !== null}
                style={{
                  flex: 1,
                  padding: "12px",
                  background: "#dc2626",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                {deleteLoading == deleteModal.vehicle?.vehicle_id ? (
                  <>
                    <i
                      className="fas fa-spinner fa-spin"
                      style={{ marginRight: "5px" }}
                    ></i>
                    Deleting...
                  </>
                ) : (
                  "Delete"
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Customer Details Modal */}
      {customerModal.isOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            padding: "20px",
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "12px",
              width: "100%",
              maxWidth: "500px",
              maxHeight: "70vh",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "20px",
                borderBottom: "1px solid #e2e8f0",
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#2d3748",
                }}
              >
                Customer Details
              </h3>
              <button
                onClick={closeCustomerModal}
                style={{
                  background: "transparent",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                  color: "#718096",
                }}
              >
                ×
              </button>
            </div>

            <div style={{ flex: 1, overflowY: "auto", padding: "20px" }}>
              {customerModal.loading ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "40px 20px",
                    color: "#666",
                  }}
                >
                  <div
                    className="loading-spinner"
                    style={{ margin: "0 auto 15px" }}
                  ></div>
                  Loading customer details...
                </div>
              ) : customerModal.customer ? (
                <div className="customer-detail-section">
                  <div
                    style={{
                      textAlign: "center",
                      marginBottom: "24px",
                      paddingBottom: "16px",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <h4
                      style={{
                        margin: 0,
                        color: "#2d3748",
                        fontSize: "1.5rem",
                        fontWeight: "600",
                      }}
                    >
                      {customerModal.customer.customer_name}
                    </h4>
                  </div>

                  <div style={{ marginBottom: "24px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "12px",
                        marginBottom: "16px",
                        padding: "12px",
                        background: "#f8f9fa",
                        borderRadius: "8px",
                      }}
                    >
                      <i
                        className="fas fa-building"
                        style={{
                          color: "#667eea",
                          fontSize: "1.1rem",
                          marginTop: "2px",
                        }}
                      ></i>
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            display: "block",
                            fontSize: "0.85rem",
                            color: "#6b7280",
                            marginBottom: "4px",
                            fontWeight: "500",
                          }}
                        >
                          Company
                        </div>
                        <div
                          style={{
                            display: "block",
                            color: "#4a5568",
                            wordBreak: "break-word",
                          }}
                        >
                          {customerModal.customer.customer_company_name ||
                            "N/A"}
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "12px",
                        marginBottom: "16px",
                        padding: "12px",
                        background: "#f8f9fa",
                        borderRadius: "8px",
                      }}
                    >
                      <i
                        className="fas fa-phone"
                        style={{
                          color: "#667eea",
                          fontSize: "1.1rem",
                          marginTop: "2px",
                        }}
                      ></i>
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            display: "block",
                            fontSize: "0.85rem",
                            color: "#6b7280",
                            marginBottom: "4px",
                            fontWeight: "500",
                          }}
                        >
                          Mobile
                        </div>
                        <div
                          style={{
                            display: "block",
                            color: "#4a5568",
                            wordBreak: "break-word",
                          }}
                        >
                          {customerModal.customer.customer_mobile || "N/A"}
                        </div>
                      </div>
                    </div>

                    {customerModal.customer.customer_email && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: "12px",
                          marginBottom: "16px",
                          padding: "12px",
                          background: "#f8f9fa",
                          borderRadius: "8px",
                        }}
                      >
                        <i
                          className="fas fa-envelope"
                          style={{
                            color: "#667eea",
                            fontSize: "1.1rem",
                            marginTop: "2px",
                          }}
                        ></i>
                        <div style={{ flex: 1 }}>
                          <div
                            style={{
                              display: "block",
                              fontSize: "0.85rem",
                              color: "#6b7280",
                              marginBottom: "4px",
                              fontWeight: "500",
                            }}
                          >
                            Email
                          </div>
                          <div
                            style={{
                              display: "block",
                              color: "#4a5568",
                              wordBreak: "break-word",
                            }}
                          >
                            {customerModal.customer.customer_email}
                          </div>
                        </div>
                      </div>
                    )}

                    {customerModal.customer.customer_area && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: "12px",
                          marginBottom: "16px",
                          padding: "12px",
                          background: "#f8f9fa",
                          borderRadius: "8px",
                        }}
                      >
                        <i
                          className="fas fa-map-marker-alt"
                          style={{
                            color: "#667eea",
                            fontSize: "1.1rem",
                            marginTop: "2px",
                          }}
                        ></i>
                        <div style={{ flex: 1 }}>
                          <div
                            style={{
                              display: "block",
                              fontSize: "0.85rem",
                              color: "#6b7280",
                              marginBottom: "4px",
                              fontWeight: "500",
                            }}
                          >
                            Area
                          </div>
                          <div
                            style={{
                              display: "block",
                              color: "#4a5568",
                              wordBreak: "break-word",
                            }}
                          >
                            {customerModal.customer.customer_area}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div
                    style={{
                      paddingTop: "16px",
                      borderTop: "1px solid #e5e7eb",
                      textAlign: "center",
                    }}
                  >
                    <button
                      onClick={() => handleEditCustomer(customerModal.customer)}
                      style={{
                        background: "#ed8936",
                        color: "white",
                        border: "none",
                        padding: "12px 24px",
                        borderRadius: "8px",
                        cursor: "pointer",
                        fontSize: "1rem",
                        fontWeight: "500",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        transition: "background 0.2s ease",
                        margin: "0 auto",
                      }}
                    >
                      <i className="fas fa-edit"></i> Edit Customer
                    </button>
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    padding: "40px 20px",
                    color: "#718096",
                  }}
                >
                  Customer details not found.
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        .history-container {
          min-height: 100vh;
          background: white;
          padding: 0;
          position: relative;
        }

        /* Sticky Filter Styles */
        .sticky-filter {
          position: sticky;
          top: 0;
          z-index: 100;
          background: white;
          padding: 8px 0;
          border-bottom: 1px solid #e2e8f0;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        .content-area {
          padding-top: 8px;
          padding-bottom: 80px;
        }

        /* Search/Filters Section */
        .home-icon .section-home {
          padding: 8px 12px 12px 12px;
        }
        .home-icon {
          padding-left: 0px;
          padding-right: 0px;
        }

        .input-group.same-line {
          display: flex;
          gap: 12px;
          align-items: center;
        }

        .input-group.same-line .search-input {
          flex: 1;
        }

        .search-input {
          padding: 12px;
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          font-size: 14px;
          background: #f8f9fa;
          width: 100%;
        }

        .search-btn {
          background: #0352a1;
          color: white;
          border: none;
          border-radius: 12px;
          padding: 13px 15px;
          min-width: 40px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        /* Vehicles List */
        .home-vehicles {
          padding: 30px 10px;
        }

        .loading-vehicles {
          text-align: center;
          padding: 40px 20px;
          color: #666;
        }

        .loading-spinner {
          width: 30px;
          height: 30px;
          border: 3px solid #f3f3f3;
          border-top: 3px solid #0352a1;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin: 0 auto 15px;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        .vehicles-list {
          display: grid;
          gap: 15px;
        }

        .vehicle-card {
          background: #f8f9fa;
          border-radius: 12px;
          padding: 16px;
          border-left: 4px solid #0352a1;
          transition: all 0.3s ease;
        }

        .vehicle-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .vehicle-header {
          width: 100%;
        }

        .vehicle-header table {
          width: 100%;
          border-collapse: collapse;
        }

        .vehicle-header td {
          padding: 4px 0;
          vertical-align: top;
        }

        /* No Vehicles State */
        .no-vehicles {
          text-align: center;
          padding: 40px 20px;
          background: #f8f9fa;
          border-radius: 12px;
          margin: 20px 0;
        }

        .no-vehicles-icon {
          font-size: 48px;
          margin-bottom: 15px;
        }

        .no-vehicles-title {
          font-size: 18px;
          font-weight: 600;
          color: #2c3e50;
          margin-bottom: 8px;
        }

        .no-vehicles-text {
          color: #666;
          margin-bottom: 20px;
        }

        /* Floating Add Button */
        .floating-add-btn {
          position: fixed;
          bottom: 80px;
          right: 20px;
          width: 60px;
          height: 60px;
          background: #0352a1;
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          cursor: pointer;
          box-shadow: 0 4px 12px rgba(3, 82, 161, 0.3);
          z-index: 99;
          transition: all 0.3s ease;
          border: none;
        }

        .floating-add-btn:hover {
          transform: scale(1.1);
          box-shadow: 0 6px 16px rgba(3, 82, 161, 0.4);
        }

        .floating-add-btn:active {
          transform: scale(0.95);
        }

        @media (max-width: 768px) {
          .content-area {
            padding-top: 60px;
          }

          .home-vehicles {
            padding: 25px 10px;
          }

          .vehicle-card {
            padding: 12px;
          }

          .vehicle-header td {
            font-size: 14px;
          }

          .sticky-filter {
            padding: 6px 0;
          }

          .floating-add-btn {
            bottom: 70px;
            right: 15px;
            width: 56px;
            height: 56px;
            font-size: 22px;
          }
        }

        @media (max-width: 480px) {
          .sticky-filter {
            padding: 4px 0;
          }

          .floating-add-btn {
            bottom: 60px;
            right: 12px;
            width: 52px;
            height: 52px;
            font-size: 20px;
          }
        }
      `}</style>
    </div>
  );
};

export default Vehicles;
